import {FC} from 'react'
import {getIcon} from './iconMap'
import {getMenuSpriteHref} from './generatedMenuSprite'

type Props = {
  icon?: string
  size?: number
  className?: string
}

function isImagePath(path?: string): boolean {
  if (!path) return false
  return (
    path.endsWith('.svg') ||
    path.endsWith('.png') ||
    path.endsWith('.jpg') ||
    path.endsWith('.webp') ||
    path.endsWith('.gif')
  )
}

const MenuIcon: FC<Props> = ({icon, size = 20, className = ''}) => {
  if (!icon) return null

  const spriteHref = getMenuSpriteHref(icon)
  if (spriteHref) {
    return (
      <svg
        width={size}
        height={size}
        className={'object-contain flex-shrink-0 ' + className}
        aria-hidden='true'
        focusable='false'
      >
        <use href={spriteHref} xlinkHref={spriteHref} />
      </svg>
    )
  }

  if (isImagePath(icon)) {
    return (
      <img
        src={icon}
        alt=''
        width={size}
        height={size}
        className={`object-contain flex-shrink-0 ${className}`}
        aria-hidden='true'
      />
    )
  }

  const LucideIcon = getIcon(icon)
  if (LucideIcon) {
    return <LucideIcon size={size} strokeWidth={1.8} className={className} />
  }

  return null
}

export {MenuIcon}
